import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroupDirective, NgForm, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { FormBuilder } from '@angular/forms';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AuthService } from '../../shared/services/AuthService';
import { AuthenticationService } from '../services/authentication.service';
import { ErrorStateMatcher } from '@angular/material';
import { TRANSLATE } from '../../shared/classes/translatable';
import { AlertService } from '../../shared/services/alert.service';

export class MyErrorStateMatcher implements ErrorStateMatcher {
    isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
      const invalidCtrl = !!(control && control.parent &&control.invalid && control.parent.dirty);
      const invalidParent = !!(control && control.parent && control.parent.invalid && control.parent.dirty);
      return control.parent.errors && control.parent.errors  && control.touched && ( invalidCtrl || invalidParent );
    }
}

@Component({
  selector: 'app-password-oublie',
  templateUrl: './password-oublie.component.html',
  styleUrls: ['./password-oublie.component.css']
})
export class PasswordOublieComponent implements OnInit {

  constructor(
    private formBuilder: FormBuilder,
    private authService: AuthenticationService,
    private router: Router,
    private route: ActivatedRoute,
    private alertService: AlertService
  ) { }

  resetForm: FormGroup;
  typeTextPassword = "password"
  changeForm: FormGroup;
  loading = false;
  token: string = null;
  pwdPattern = "^(?=.*\\d)(?=.*[a-z])(?=.*[-_!@#$%^&*])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$"

  paramsSub: Subscription;

  matcher = new MyErrorStateMatcher();

  checkPasswords: ValidatorFn = (group: AbstractControl):  ValidationErrors | null => { 
    let pass = group.get('password').value;
    let confirmPass = group.get('confirmPassword').value
    return pass === confirmPass ? null : { notSame: true }
  }

  changeType() {
    if (this.typeTextPassword == "password") {
      this.typeTextPassword = "text"
    } else {
      this.typeTextPassword = "password"
    }
  }

  ngOnInit() {
    this.resetForm = this.formBuilder.group({
      mail: ['', Validators.required],
      login: ['', Validators.required]
    });

    this.changeForm = this.formBuilder.group({
        password: ['', [Validators.required, Validators.pattern(this.pwdPattern)]],
        confirmPassword: ['']
    });
  
    this.changeForm.setValidators(this.checkPasswords)
    
    this.paramsSub = this.route.params.subscribe(params => {
      if (params.token) {
        this.token = params.token
      }
    })
    
    this.authService.verifyOneTimeToken(this.token).subscribe(retour => {
      if (retour.message == "Token invalide" && this.token !== null) {
        this.router.navigate(['/login']);
        this.alertService.error(TRANSLATE("Le lien de regénération de mot de passe est expiré ou a déjà été utilisé. Veuillez faire une nouvelle demande de réinitialisation."));
      }
    });
  }

    onClick() {
        this.loading = true
        let data = {login: this.resetForm.get("login").value, mail: this.resetForm.get("mail").value}

        this.authService.demandePasswordChange(data).subscribe(retour => {
            this.router.navigate(['/login']);
            if (retour.data == "1") {
                this.alertService.success(TRANSLATE("Si l'adresse mail est liée à votre compte, un email vous a été envoyé !"), false, false)
            }
        })
    }

    onClickChange() {
        this.loading = true;
        if (!this.changeForm.valid) {
            return;
        }

        let data = {
            token: this.token,
            password: this.changeForm.get('password').value
        }

        this.authService.changePassword(data).subscribe(retour => {
            this.router.navigate(['/login']);
            if (retour.data == 1) {
                this.alertService.success(TRANSLATE("Mot de passe modifié avec succès !"))
            }
        })
    }
}